import { MenuItem, SelectTextField, Stack, TextField, ToggleSwitch, Loader } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { useFormContext, Controller } from "react-hook-form"
import { errorHandling } from "@tm/utils"
import { useRepairTimesFormDefaults } from "@bundles/basket/hooks/Forms/useRepairTimesFormDefaults"
import { FixedPriceFields } from "./FixedPriceFields"
import { HourlyRateFields } from "./HourlyRateFields"

type EditDialogBodyProps = {
    hasFixedPrice: boolean
    onChangeHasFixedPrice(value: boolean): void
}

export function EditDialogBody(props: EditDialogBodyProps) {
    const { hasFixedPrice, onChangeHasFixedPrice } = props
    const { translateText } = useLocalization()
    const { control } = useFormContext()
    const { vatRateItems, workCategoryItems } = useRepairTimesFormDefaults()

    if (!workCategoryItems) {
        return <Loader />
    }

    return (
        <Stack spacing={1}>
            <Stack direction="row" gap={1}>
                <Controller
                    control={control}
                    name="workId"
                    render={({ field, fieldState }) => (
                        <TextField label={translateText(58)} size="extralarge" sx={{ width: "235px" }} {...field} {...errorHandling(fieldState)} />
                    )}
                />
                <Controller
                    control={control}
                    name="description"
                    render={({ field, fieldState }) => (
                        <TextField
                            required
                            label={translateText(25)}
                            size="extralarge"
                            sx={{ width: "435px" }}
                            {...field}
                            {...errorHandling(fieldState)}
                        />
                    )}
                />
                <Controller
                    control={control}
                    name="category"
                    render={({ field, fieldState }) => (
                        <SelectTextField
                            required
                            label={translateText(158)}
                            size="extralarge"
                            maxLayerHeight={300}
                            sx={{ width: "380px" }}
                            {...field}
                            {...errorHandling(fieldState)}
                        >
                            {workCategoryItems?.map((cat) => (
                                <MenuItem key={cat.category} value={cat.category}>
                                    {cat.text}
                                </MenuItem>
                            )) || []}
                        </SelectTextField>
                    )}
                />
            </Stack>
            <Stack direction="row" gap={1}>
                <ToggleSwitch
                    size="small"
                    right={{ value: translateText(246), key: true }}
                    left={{ value: translateText(63), key: true }}
                    selected={hasFixedPrice}
                    onChange={() => onChangeHasFixedPrice(!hasFixedPrice)}
                />

                {hasFixedPrice ? <FixedPriceFields /> : <HourlyRateFields />}

                <Controller
                    control={control}
                    name="vatType"
                    render={({ field, fieldState }) => (
                        <SelectTextField
                            label={translateText(706)}
                            size="extralarge"
                            sx={{ width: "250px" }}
                            {...field}
                            {...errorHandling(fieldState)}
                        >
                            {vatRateItems.map(({ vatRate, text }) => (
                                <MenuItem key={vatRate.vatType} value={vatRate.vatType}>
                                    {text}
                                </MenuItem>
                            ))}
                        </SelectTextField>
                    )}
                />
            </Stack>
        </Stack>
    )
}
